<template>
    <div class="driver-info-item">
        <div class="second_header">
            <p v-if="isFirst" class="second_header--title">
                {{ trans("title") }}
            </p>

            <p class="second_header--subtitle">{{ trans(subTitle) }}</p>
        </div>
        <div class="driver-sex">
            <app-label>{{ trans("driver_sex") }}</app-label>
            <app-text-radio-buttons
                v-model="driverInfo.sex"
                :items="driverSex"
                :message="getError('sex')"
            >
            </app-text-radio-buttons>
        </div>

        <div class="driver-birth">
            <app-label>{{ trans("driver_birth") }}</app-label>

            <date-input
                v-model="driverInfo.birth"
                :disabled-dates="disabledBirth"
                :message="getError('birth')"
                :open-date="startingDate"
                :typeable="true"
                icon="calendar_new"
                manual
            />
        </div>

        <div class="driver-license">
            <app-label>{{ trans("driver_license_year") }}</app-label>

            <app-box-input
                v-model="driverInfo.licenseIssued"
                :message="getError('licenseIssued')"
                label="year"
                :licenseYear="true"
                placeholder="inputs.license_issued"
                small
                type="number"
            ></app-box-input>
        </div>
    </div>
</template>

<script>
import DateInput from "../Forms/DateInput";
import AppAutocompleteInput from "../Forms/AutocomplateInput";

import MaskedInput from "vue-masked-input";

export default {
    components: {
        DateInput,
        MaskedInput,
        AppAutocompleteInput
    },
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        trans: {
            type: Function
        },
        errors: {
            type: Object,
            default: () => ({})
        },
        constants: {
            type: Object,
            default: () => ({})
        },
        disabled: {
            type: Boolean,
            default: false
        },
        title: {
            type: [String, Boolean],
            default: false
        },
        errorKey: {
            type: [String],
            default: false
        },
        isFirst: {
            type: Boolean,
            default: false
        },
        subTitle: {
            type: String,
            default: "subtitle"
        }
    },
    data() {
        const date = new Date();
        const year = date.getFullYear();

        return {
            driverInfo: this.value,
            startingDate: new Date(year - 17, date.getMonth(), date.getDay()),
            disabledBirth: {
                from: new Date(year - 17, date.getMonth(), date.getDay())
            },
            localMonth: [
                "ינואר",
                "פברואר",
                "מרץ",
                "אפריל",
                "מאי",
                "יוני",
                "יולי",
                "אוגוסט",
                "ספטמבר",
                "אוקטובר",
                "נובמבר",
                "דצמבר"
            ]
        };
    },
    mounted() {
        jQuery(".day__month_btn.up").on("click", () => {
            jQuery(".month__year_btn.up").trigger("click");
        });
    },
    watch: {
        value() {
            this.driverInfo = this.value;
        },
        driverInfo() {
            this.$emit("input", this.driverInfo);
        }
    },
    methods: {
        getError(key) {
            return this.errors.get(`${this.errorKey}.${key}`);
        }
    },
    computed: {
        driverSex() {
            return [
                {
                    label: this.trans("male"),
                    value: this.constants.SEX_MAN,
                    icon: "male",
                    icon_checked: "male_checked"
                },
                {
                    label: this.trans("female"),
                    value: this.constants.SEX_WOMAN,
                    icon: "female",
                    icon_checked: "female_checked"
                }
            ];
        }
    }
};
</script>

<style lang="scss">
.driver-info-item {
    position: relative;
    width: 800px;

    .driver-label {
        font-size: 24px;
        margin-left: 30px;
        min-width: 180px;

        @media all and (max-width: $mobile) {
            font-size: 19px;
            min-width: auto;
        }
    }

    .driver-sex {
        display: flex;
        margin-top: 25px;
        flex-direction: column;
        justify-content: flex-start;

        @media all and (max-width: $mobile) {
            justify-content: space-between;
        }

        .radio-buttons-wrap {
            label {
                flex: 1;
            }
        }
    }

    .driver-birth {
        display: flex;
        margin-top: 25px;
        flex-direction: column;
        justify-content: flex-start;

        @media all and (max-width: $mobile) {
            justify-content: space-between;
        }

        .app-date-input {
            width: 100%;
            border-radius: 100px;
            border: 1px solid rgba(33, 67, 146, 0.2);
            background: $lightest-gray;

            input {
                font-size: 24px;
                height: 50px;
                margin: 0;

                @media all and (max-width: $mobile) {
                    font-size: 21px;
                }
            }
        }
    }

    .birthday-picker input {
        font-size: 24px;

        &:focus-visible {
            outline-color: $primary-blue;
        }
    }

    .birthday-picker_carriage:after {
        content: none;
    }

    .driver-license {
        display: flex;
        flex-direction: column;
        margin-top: 25px;

        .app-box-input {
            .box-input-wrap {
                height: 50px;
                width: 100% !important;
            }
        }

        @media all and (max-width: $mobile) {
            justify-content: space-between;
        }

        .box-input-wrap {
            height: 45px;
            width: 180px !important;

            input {
                font-size: 24px;

                @media all and (max-width: $mobile) {
                    font-size: 21px;
                }
            }
        }
    }
}
</style>
